/** Schritt 6 „Nachrichten“ inkl. „Flow testen“. */
const wizMessagesDE = {
  wizMsgLockedNote: 'So läuft der Ablauf dieser Kampagne gerade. Änderungen daran machst du im Flow-Editor.',
  wizMsgTitle: 'Nachrichten-Ablauf',
  wizMsgSubtitle:
    'SAIA schreibt jede Nachricht individuell für jeden Kandidaten – aus Briefing, Profil und deinen Angaben zur Ansprache. Der Ablauf verzweigt je nachdem, wie der Kontakt reagiert.',
  wizMsgChangeApproach: 'Ansprache ändern',
  wizMsgChatCount: 'Passe die Anzahl der Chat-Nachrichten an.',
  wizMsgChatCountAria: 'Anzahl der Chat-Nachrichten: {{count}}',
  wizMsgChatCountHint: 'max. pro Kandidat, ohne InMails, zzgl. Empfehlungs-Frage (wenn ausgewählt)',
  wizMsgSummary: '{{count}} Nachrichten',
  wizMsgSummaryInmails: ', davon {{count}} InMails',
  wizMsgPlanLoading: 'Ablauf wird berechnet …',
  wizMsgPlanError: 'Der Ablauf konnte nicht berechnet werden.',
  wizMsgTestTitle: 'Flow testen',
  wizMsgTestSubtitle:
    'Wähle ein Profil aus deiner Suche. SAIA schreibt den kompletten Ablauf für diese Person, alle Nachrichten in der Reihenfolge des Ablaufs – nichts wird gesendet.',
  wizMsgTestRun: 'Flow testen',
  wizMsgTestRerun: 'Erneut testen',
  wizMsgNoCandidates:
    'Sobald die ersten Kandidaten aus der Suche da sind, kannst du den Ablauf an einem echten Profil testen.',
  wizMsgCandidatesLoading: 'Kandidaten werden geladen …',
  wizMsgBlocked: 'Firma auf Blacklist – wird nicht angesprochen',
  wizMsgTestLoading:
    'SAIA schreibt den kompletten Ablauf für dieses Profil. Das kann einige Minuten dauern; das Ergebnis erscheint automatisch, du musst nichts weiter tun.',
  wizMsgTestPreparing: 'Der Ablauf wird gerade gespeichert, der Test startet gleich …',
  wizMsgTestStale: 'Profil oder Ablauf geändert – klick auf „Erneut testen“.',
  wizMsgTestFor: 'Beispiel für {{name}} · wird nicht gesendet',
  wizMsgTestSourceAi: 'Von SAIA (KI) für dieses Profil geschrieben',
  wizMsgTestSourceTemplate: 'KI nicht erreichbar – Vorlage mit Namen gefüllt',
  wizMsgTestError: 'Der Test ist fehlgeschlagen.',
  wizMsgNoText: '(ohne Nachricht)',
  wizWaitEditHint: 'Zeit anpassen',
  wizWaitChanged: 'angepasst',
  wizWaitTitle: 'Wartezeit anpassen',
  wizWaitAcceptTitle: 'Wie lange auf die Annahme warten?',
  wizWaitHint: 'Stelle die Zeit in Tagen, Stunden und Minuten ein.',
  wizWaitDays: 'Tage',
  wizWaitHours: 'Stunden',
  wizWaitMinutes: 'Minuten',
  wizWaitDay: 'Tag',
  wizWaitHour: 'Stunde',
  wizWaitMinute: 'Minute',
  wizWaitDefault: 'Standard: {{value}}',
  wizWaitReset: 'Auf Standard zurücksetzen',
  wizWaitTooShort: 'Die Zeit ist zu kurz (mindestens {{min}}).',
  wizWaitTooLong: 'Die Zeit ist zu lang (höchstens 90 Tage).',
  wizWaitCancel: 'Abbrechen',
  wizWaitSave: 'Übernehmen',
};
export default wizMessagesDE;
